import React, { lazy, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PrivateRoute from 'routing/private-route';
import ProtectedRoute from 'routing/protected-route';
import RoutingSuspense from 'components/RoutingSuspense';
import { useDispatch } from 'react-redux';
import { fetchReferralLinks } from 'products/nomad_insurance/state/referrals';
import { internalRedirect } from 'helpers';

const Dashboard = lazy(() => import('./Dashboard'));
const Update = lazy(() => import('./Update'));
const Signup = lazy(() => import('./Signup'));
const Login = lazy(() => import('./Login'));
const Registration = lazy(() => import('./Registration'));

const Routing = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchReferralLinks());
  }, []);

  return (
    <RoutingSuspense>
      <Switch>
        <Route exact path="/ambassador" render={() => internalRedirect('/ambassador')} />
        <PrivateRoute
          exact
          path="/ambassador/dashboard"
          component={Dashboard}
          product="ambassador"
        />
        <Route
          exact
          path="/ambassador/refer/:urlName"
          render={({ match }) => {
            if (match.params.urlName) {
              localStorage.setItem('ambassadorPromoterUrlName', match.params.urlName);
            }
            return <Redirect to="/ambassador" />;
          }}
        />
        <ProtectedRoute
          exact
          path="/ambassador/signup"
          component={Signup}
          product="ambassador"
        />
        <ProtectedRoute
          exact
          path="/ambassador/login"
          component={Login}
          product="ambassador"
        />
        <PrivateRoute
          exact
          path="/ambassador/update/:step(info|contract)"
          product="ambassador"
          component={Update}
        />
        <PrivateRoute
          exact
          path="/ambassador/registration/:step(intro|terms|info|agreement|welcome)?"
          component={Registration}
          product="ambassador"
        />
      </Switch>
    </RoutingSuspense>
  );
};

export default Routing;
